import React from "react";
import { useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import { APIContext } from "../../context";

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  formControl: {
    //padding: theme.spacing(1, 2, 2 , 2),
  },
  TituloForm: {
    textTransform: "Uppercase",
    fontWeight: "600",
    marginBottom: theme.spacing(2),
  },
  SubTituloForm: {
    marginBottom: theme.spacing(2),
  },
  Divider: {
    margin: theme.spacing(3, 0, 3, 0),
    backgroundColor: theme.palette.primary.main,
    height: "2px",
  },
  Input: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.primary.main,
  },
  InputBase: {
    textTransform: "Uppercase",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.secondary.main,
  },
  card: {
    // boxShadow: 'none',
    backgroundColor: "#fff",
    color: theme.palette.secondary.main,
    padding: theme.spacing(2, 2, 2, 2),
    borderColor: "#cccecea3",
    marginBottom: theme.spacing(3),
  },
  containerButton: {
    textAlign: "center",
  },
  buttonCalcular: {
    textTransform: "capitalize",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    lineHeight: "1.5rem",
    letterSpacing: "0.1rem",
    fontSize: "1.2rem",
    color: "#fff",
    float: "right",
  },
  label: {
    width: "280px",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  input: {
    [theme.breakpoints.up("sm")]: {
      width: 400,
    },
  },
  boxContainer: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    flexDirection: "row",
  },
}));

export default function PrecalificacionRow(props) {
  const classes = useStyles();
  const history = useHistory();

  const { loggedUser, getPrecalificacion, updatePrecalificacion, sectores } =
    useContext(APIContext);
  const [data, setData] = useState({
    empresa_razsoc: "",
    empresa_nomcom: "",
    empresa_ruc: "",
    repleg_nombre: "",
    repleg_cedula: "",
    empresa_email: "",
    empresa_numcont: "",
    sect_id: 0,
    empresa_descrip: "",
    ventas_mes_promedio: 0,
    ventas_ano_anterior: 0,

    cliente_1_nom: "",
    cliente_1_ruc: "",
    cliente_1_monto: 0,
    cliente_1_plazo: 0,
    cliente_2_nom: "",
    cliente_2_ruc: "",
    cliente_2_monto: 0,
    cliente_2_plazo: 0,
    cliente_3_nom: "",
    cliente_3_ruc: "",
    cliente_3_monto: 0,
    cliente_3_plazo: 0,
    cliente_4_nom: "",
    cliente_4_ruc: "",
    cliente_4_monto: 0,
    cliente_4_plazo: 0,
    cliente_5_nom: "",
    cliente_5_ruc: "",
    cliente_5_monto: 0,
    cliente_5_plazo: 0,

    acepto_buro: false,
    acepto_revisar: false,
  });

  const [permiso, setPermiso] = useState(false);

  async function buscar_precalificacion() {
    setData(await getPrecalificacion(props.id));
  }

  useEffect(() => {
    if (loggedUser) {
      if (loggedUser.ase_rol < 4) {
        setPermiso(true);
      }
    }
  }, [loggedUser]);

  useEffect(() => {
    buscar_precalificacion();
  }, []);

  return (
    <>
      <Card className={classes.card} variant="outlined">
        <CardContent className={classes.FormBase}>
          <Box display="flex" flexDirection="column" p={0} mt={3}>
            {/* <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography   color="primary" align="left">
                  Fecha de creación
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.fecha}
                  variant="outlined"
                  placeholder="Empresa Razón social"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box> */}
            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Razón Social
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.empresa_razsoc}
                  variant="outlined"
                  placeholder="Empresa Razón social"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>
            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre comercial
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  name="empresa_nomcom"
                  value={data.empresa_nomcom}
                  variant="outlined"
                  placeholder="Nombre comercial"
                  //fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>
            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.empresa_ruc}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre representante legal
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.repleg_nombre}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Número de Cédula
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.repleg_cedula}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Email
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.empresa_email}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Número Contacto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.empresa_numcont}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Sector Económico
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  name="sector_economico"
                  value={data.sect_nombre}
                  variant="outlined"
                  placeholder="Sector económico"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Ventas USD mes promedio
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  name="ventas_mes_promedio"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.ventas_mes_promedio}
                  variant="outlined"
                  placeholder="Total de Ventas del mes Anterior"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Ventas Totales USD Año anterior
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  name="ventas_ano_anterior"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.ventas_ano_anterior}
                  variant="outlined"
                  placeholder="Total de Ventas del Año anterior"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={3}>
              <Box className={classes.label} mr={4}>
                <Typography variant="h5" color="primary" align="left">
                  5 Clientes a Negociar
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="secondary" align="left">
                  Primer Cliente
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_1_nom}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_1_ruc}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Monto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.cliente_1_monto}
                  variant="outlined"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Plazo (# días)
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_1_plazo}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="secondary" align="left">
                  Segundo Cliente
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_2_nom}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_2_ruc}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Monto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.cliente_2_monto}
                  variant="outlined"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Plazo (# días)
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_2_plazo}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="secondary" align="left">
                  Tercer Cliente
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_3_nom}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_3_ruc}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Monto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.cliente_3_monto}
                  variant="outlined"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Plazo (# días)
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_3_plazo}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="secondary" align="left">
                  Cuarto Cliente
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_4_nom}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_4_ruc}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Monto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.cliente_4_monto}
                  variant="outlined"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Plazo (# días)
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_4_plazo}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="secondary" align="left">
                  Quinto Cliente
                </Typography>
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Nombre
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_5_nom}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  RUC
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_5_ruc}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Monto
                </Typography>
              </Box>
              <Box className={classes.input}>
                <CurrencyTextField
                  decimalCharacter=","
                  digitGroupSeparator="."
                  value={data.cliente_5_monto}
                  variant="outlined"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" className={classes.boxContainer} p={0} my={1}>
              <Box className={classes.label} mr={4}>
                <Typography color="primary" align="left">
                  Plazo (# días)
                </Typography>
              </Box>
              <Box className={classes.input}>
                <TextField
                  value={data.cliente_5_plazo}
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{
                    disabled: true,
                  }}
                />
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              p={0}
              my={1}
              justifyContent="center"
            >
              <Box width="80%" mr={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      //value="allowExtraEmails"
                      checked={data.acepto_revisar}
                      color="primary"
                    />
                  }
                  label="Autorización a revisar información pública: SUPERCIAS, SRI, IESS, Función Judical."
                />
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              p={0}
              my={1}
              justifyContent="center"
            >
              <Box width="80%" mr={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      //value="allowExtraEmails"
                      checked={data.acepto_buro}
                      color="primary"
                    />
                  }
                  label="Autorización a revisar buró de crédito: EQUIFAX PARA EMPRESA, ADMINISTRADORES Y ACCIONISTAS"
                />
              </Box>
            </Box>

            {data.estado < 1 && (
              <>
                {permiso && (
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-evenly"
                    p={0}
                    mt={3}
                  >
                    <Button
                      //variant="contained"
                      color="warning"
                      size="large"
                      //className={classes.buttonCalcular}
                      onClick={async () => {
                        await updatePrecalificacion(data, 2);
                        history.goBack();
                      }}
                      disableElevation
                      //disabled={ !enabled}
                    >
                      Rechazar
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      className={classes.buttonCalcular}
                      onClick={async () => {
                        //await createPrecalificacion(data),
                        await updatePrecalificacion(data, 1);
                        history.goBack();
                      }}
                      disableElevation
                      //disabled={ !enabled}
                    >
                      Aprobar
                    </Button>
                  </Box>
                )}
              </>
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
